(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('CampaignFactory', CampaignFactory);

    CampaignFactory.$inject = ['$resource'];

    function CampaignFactory ($resource) {
        var resourceUrl =  'admin/api/campaign';

        return $resource(resourceUrl, {}, {
            'listAll': {
                url: resourceUrl + '/list',
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'save': {
              url: resourceUrl,
              method: 'POST'
            },
            'update': { method:'PUT' },
            'delete': {
                method:'DELETE',
                url: resourceUrl + '/:id',
            },
            'distribute': {
                method: 'POST',
                url: resourceUrl + '/:id/distribute'
            },
            'activateOrInactivate': {
                method: 'PUT',
                url: resourceUrl + '/:id/activate-inactivate'
            },
            'get': {
                url: resourceUrl + '/:id',
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getCampaignSettings': {
                url: 'admin/api/store/campaign-settings',
                method: 'GET'
            },
            'saveCampaignSettings': {
                url: 'admin/api/store/campaign-settings',
                method: 'PUT'
            }
        });
    }
})();
